update_breaks();
update_breaks_price();
setTimeout(function() {
  update__price();
}, 2000);

$(document).on("click","#quantity1, #quantity2, #quantity3, #quantity4",function() {
  $('.breaks-inputs').removeClass('active');
  $(this).prev("input[type='radio']").prop("checked", true);
  $(this).next().find('.breaks-inputs').addClass('active');
  update_breaks();
  update_breaks_price()
});

$(document).on("change",".quantity-break__variant-select",function() {
  var id = $(this).val()
  var index = $(this).parents('.quantity-break__selector-item').data('select-index')

  $(this).parents('.quantity-break').find('.breaks-inputs input[data-select-index="'+index+'"]').val(id);
  update_breaks();
  update_breaks_price()
});
  
function update_breaks() {
  var inputs_Html = $('.breaks-inputs.active').html();
  
  $('.product-form__variants').html('');
  $('.product-form__variants').html(inputs_Html);
}

function update_breaks_price() {
  if($('.quantity-breaks-container [name="quantity"]:checked').length > 0){ 
  $('.lumin-price').addClass('price--on-sale');
  $('.price__container').addClass('price--on-sale');
    
  var qty = $('.quantity-breaks-container [name="quantity"]:checked').val();
  var price = $('.quantity-breaks-container [name="quantity"]:checked').next().find('[data-text="[price]"]').text().trim();
  var compare = $('.quantity-breaks-container [name="quantity"]:checked').next().find('[data-text="[compare_price]"]').text().trim();

  $('.price-item--sale').text(price);
  $('.price-item--regular').text(compare);
  }
}

function update__price() {
  if($('.product-info').length > 0){
  var price = $('.product-info .price-item--sale').text().trim();
  var compare = $('.product__info-container .price--on-sale .price__sale .price-item--regular').text().trim();

  $('.price-item--sale').text(price);
  $('.price-item--regular').text(compare);
  }
}







// (function() {
//     function initProductVideo() {
//         document.querySelectorAll(".product-showcase__video").forEach(wrap => {
//             const video = wrap.querySelector(".product-showcase__video-el"),
//                 playBtn = wrap.querySelector(".product-showcase__video-play");
//             if (!video || !playBtn) return;
//             const hasAutoplay = video.hasAttribute("autoplay");
//             video.controls = !0, hasAutoplay ? (playBtn.style.display = "none", video.play().catch(() => {
//                 playBtn.style.display = ""
//             })) : (playBtn.style.display = "", video.pause());

//             function startPlayback() {
//                 try {
//                     video.play().then(() => {
//                         playBtn.style.display = "none"
//                     }).catch(() => {
//                         video.controls = !0
//                     })
//                 } catch {
//                     video.controls = !0
//                 }
//             }
//             playBtn.addEventListener("click", e => {
//                 e.preventDefault(), startPlayback()
//             }, {
//                 once: !0
//             }), video.addEventListener("click", () => {
//                 video.paused && startPlayback()
//             })
//         })
//     }
//     document.addEventListener("click", function(e) {
//         const headerClick = e.target instanceof Element ? e.target.closest(".product-showcase__subscribe--container .product-showcase__actions--header") : null;
//         if (headerClick) {
//             const container2 = headerClick.closest(".product-showcase__subscribe--container");
//             if (container2) {
//                 e.preventDefault(), isSingleLayout() ? ensureOpen(container2) : toggleDropdownByContainer(container2);
//                 return
//             }
//         }
//         const addToCartButton = e.target instanceof Element ? e.target.closest(".product-showcase__add-to-cart") : null;
//         if (addToCartButton) {
//             handleAddToCartClick(e, addToCartButton);
//             return
//         }
//         const opt = e.target instanceof Element ? e.target.closest(".product-showcase__subscribe--option") : null;
//         if (!opt) return;
//         e.preventDefault();
//         const container = opt.closest(".product-showcase__subscribe--container") || opt.closest("#subscribe-options-static, #purchase-options"),
//             atcButtons = document.querySelectorAll(".product-showcase__add-to-cart");
//         if (!container || !atcButtons.length) return;
//         container.querySelectorAll(".product-showcase__subscribe--option").forEach(el => el.classList.remove("is-selected")), opt.classList.add("is-selected"), document.querySelectorAll(".product-showcase__subscribe--option").forEach(el => el.classList.remove("is-active")), opt.classList.add("is-active");
//         const type = opt.getAttribute("data-type") || "onetime",
//             planId = opt.getAttribute("data-selling-plan-id") || "",
//             variantIdOverride = opt.getAttribute("data-variant-id") || "",
//             href = atcButtons[0].getAttribute("href") || "/cart/add",
//             url = new URL(href, window.location.origin);
//         if (url.searchParams.delete("selling_plan"), planId && url.searchParams.set("selling_plan", planId), variantIdOverride) url.searchParams.set("id", variantIdOverride);
//         else {
//             let mainVariantId = "";
//             const selBtn = document.querySelector(".product-variants--size .variant-product.variant-product-selected .variant-product__button");
//             selBtn && (mainVariantId = selBtn.getAttribute("data-variant-id") || ""), mainVariantId || (mainVariantId = new URLSearchParams(location.search).get("variant") || ""), mainVariantId && url.searchParams.set("id", mainVariantId)
//         }
//         const qs = url.searchParams.toString(),
//             newHref = qs ? url.pathname + "?" + qs : url.pathname;
//         atcButtons.forEach(btn => {
//             btn.hasAttribute("data-onetime-only") || btn.setAttribute("href", newHref)
//         });
//         const containerEl = opt.closest(".product-showcase__subscribe--container"),
//             headerTitle = (containerEl?.querySelector(".product-showcase__actions--header") || null)?.querySelector(".product-showcase__actions--header--title") || null,
//             headerPriceWrap = containerEl?.querySelector(".product-showcase__price") || null,
//             headerPriceEl = headerPriceWrap?.querySelector(".product-showcase__current-price") || null,
//             headerCompareEl = headerPriceWrap?.querySelector(".product-showcase__compare-price") || null;
//         if (headerTitle && headerPriceEl) {
//             if (!headerTitle.dataset.originalTitle) {
//                 const textNodes = Array.from(headerTitle.childNodes).filter(n => n.nodeType === Node.TEXT_NODE).map(n => (n.textContent || "").trim()).filter(t => t !== "").join(" ");
//                 headerTitle.dataset.originalTitle = textNodes || ""
//             }
//             const titleEl = opt.querySelector(".product-showcase__subscribe--options--title");
//             let titleText = "";
//             titleEl && (titleText = titleEl.childNodes && titleEl.childNodes.length ? Array.from(titleEl.childNodes).filter(n => n.nodeType === Node.TEXT_NODE).map(n => n.textContent || "").join("").trim() : (titleEl.textContent || "").trim()), titleText || (titleText = headerTitle.dataset.originalTitle || ""), !titleText && type !== "subscription" && (titleText = "One-Time Purchase"), headerTitle.innerHTML = `${titleText} <span class="product-showcase__actions--header--title--save"></span>`;
//             const headerBadge = headerTitle.querySelector(".product-showcase__actions--header--title--save"),
//                 oneOpt = document.querySelector("#subscribe-options-static")?.querySelector('.product-showcase__subscribe--option[data-type="onetime"]') || null,
//                 selectedPriceText = opt.getAttribute("data-price-text") || (opt.querySelector(".product-showcase__subscribe--options--price")?.textContent || "").trim(),
//                 selectedPriceCents = Number(opt.getAttribute("data-price") || "") || NaN;
//             if (selectedPriceText && (headerPriceEl.textContent = selectedPriceText), headerBadge) {
//                 if (type && type.startsWith("subscription")) {
//                     const basePriceText = oneOpt?.getAttribute("data-price-text") || (oneOpt?.querySelector(".product-showcase__subscribe--options--price")?.textContent || "").trim(),
//                         basePriceCents = Number(oneOpt?.getAttribute("data-price") || "") || NaN;
//                     if (headerCompareEl) {
//                         const isStarterKit = headerCompareEl.hasAttribute("data-source") && headerCompareEl.getAttribute("data-source") !== "fallback";
//                         headerCompareEl.dataset.originalCompare || (headerCompareEl.dataset.originalCompare = (headerCompareEl.textContent || "").trim()), isStarterKit ? headerCompareEl.dataset.originalCompare && (headerCompareEl.textContent = headerCompareEl.dataset.originalCompare) : basePriceText ? headerCompareEl.textContent = basePriceText : headerCompareEl.dataset.originalCompare && (headerCompareEl.textContent = headerCompareEl.dataset.originalCompare)
//                     }
//                     const badgeText = (opt.querySelector(".product-showcase__subscribe--options--title--save")?.textContent || "").trim();
//                     if (headerBadge.textContent = badgeText || "", headerBadge.style.display = badgeText ? "" : "none", headerCompareEl) {
//                         const hasCompare = !((headerCompareEl.textContent || "").trim() === (headerPriceEl.textContent || "").trim()) && !!(headerCompareEl.textContent || "").trim();
//                         headerCompareEl.style.display = hasCompare ? "" : "none", headerPriceWrap && headerPriceWrap.classList.toggle("has-compare", hasCompare)
//                     }
//                 } else if (headerBadge.textContent = "", headerBadge.style.display = "none", headerCompareEl) {
//                     headerCompareEl.dataset.originalCompare || (headerCompareEl.dataset.originalCompare = (headerCompareEl.textContent || "").trim()), headerCompareEl.textContent = headerCompareEl.dataset.originalCompare || "";
//                     const hasCompare = !((headerCompareEl.textContent || "").trim() === (headerPriceEl.textContent || "").trim()) && !!(headerCompareEl.textContent || "").trim();
//                     headerCompareEl.style.display = hasCompare ? "" : "none", headerPriceWrap && headerPriceWrap.classList.toggle("has-compare", hasCompare)
//                 }
//             }
//             const selectedTitle = (opt.querySelector(".product-showcase__subscribe--options--title")?.textContent || "").trim();
//             let compareTextForSticky = "";
//             type && type.startsWith("subscription") ? compareTextForSticky = (headerCompareEl?.textContent || "").trim() : compareTextForSticky = (headerCompareEl?.dataset.originalCompare || "").trim();
//             const hasCompareForSticky = !!compareTextForSticky && compareTextForSticky !== (headerPriceEl?.textContent || "").trim();
//             document.dispatchEvent(new CustomEvent("pdp:option-selected", {
//                 detail: {
//                     source: "main",
//                     type,
//                     planId,
//                     variantId: variantIdOverride || "",
//                     priceText: selectedPriceText,
//                     priceCents: selectedPriceCents,
//                     title: selectedTitle,
//                     compareText: compareTextForSticky,
//                     hasCompare: hasCompareForSticky
//                 }
//             })), toggleDropdown(opt), ensureStickyVisible(), toggleSubscriptionGuarantees(type)
//         }
//     }, !0);

//     function toggleSubscriptionGuarantees(type) {
//         const guarantees1 = document.getElementById("subscription-guarantees-1"),
//             guarantees2 = document.getElementById("subscription-guarantees-2"),
//             shouldShow = type && type.startsWith("subscription");
//         guarantees1 && (guarantees1.style.display = shouldShow ? "" : "none"), guarantees2 && (guarantees2.style.display = shouldShow ? "" : "none")
//     }

//     function applyCurrentSelection() {
//         const container = document.querySelector("#subscribe-options-static");
//         if (!container) return;
//         let target = container.querySelector(".product-showcase__subscribe--option.is-selected");
//         if (target || (target = container.querySelector(".product-showcase__subscribe--option")), !target) return;
//         const evt = new Event("click", {
//             bubbles: !0,
//             cancelable: !0
//         });
//         target.dispatchEvent(evt), ensureSingleOpen()
//     }

//     function enforceTwoOptionsSimplified() {
//         const root = document.querySelector("#subscribe-options-static");
//         if (!root) return;
//         const specialOpt = root.querySelector('.product-showcase__subscribe--option[data-type="subscription-special"]');
//         if (!!specialOpt) {
//             const stdSubOpt = root.querySelector('.product-showcase__subscribe--container .product-showcase__subscribe--option[data-type="subscription"]'),
//                 stdContainer = stdSubOpt ? stdSubOpt.closest(".product-showcase__subscribe--container") : null;
//             stdContainer && (stdContainer.style.display = "none", stdContainer.setAttribute("aria-hidden", "true")), root.querySelectorAll(".product-showcase__subscribe--option").forEach(el => el.classList.remove("is-selected", "is-active")), specialOpt && (specialOpt.classList.add("is-selected"), specialOpt.classList.add("is-active")), ensureSingleOpen()
//         } else {
//             const stdSubOpt = root.querySelector('.product-showcase__subscribe--container .product-showcase__subscribe--option[data-type="subscription"]'),
//                 stdContainer = stdSubOpt ? stdSubOpt.closest(".product-showcase__subscribe--container") : null;
//             stdContainer && (stdContainer.style.display = "", stdContainer.removeAttribute("aria-hidden")), ensureSingleOpen()
//         }
//     }

//     function ensureSingleOpen() {
//         if (!isSingleLayout()) return;
//         const root = document.querySelector("#subscribe-options-static");
//         if (!root) return;
//         const allContainers = root.querySelectorAll(".product-showcase__subscribe--container");
//         let visibleContainer = null;
//         allContainers.forEach(cont => {
//             !(cont.style.display === "none" || cont.getAttribute("aria-hidden") === "true") && !visibleContainer && (visibleContainer = cont)
//         }), visibleContainer && ensureOpen(visibleContainer)
//     }
//     document.addEventListener("DOMContentLoaded", () => {
//         initProductVideo(), enforceTwoOptionsSimplified(), applyCurrentSelection(), ensureStickyVisible(), ensureSingleOpen(), initMobileSwiper(), updateGuaranteesFromSelection()
//     }), document.addEventListener("pdp:product-changed", () => {
//         enforceTwoOptionsSimplified(), applyCurrentSelection(), ensureSingleOpen(), initMobileSwiper(), updateGuaranteesFromSelection()
//     });

//     function updateGuaranteesFromSelection() {
//         const container = document.querySelector("#subscribe-options-static");
//         if (!container) return;
//         const selected = container.querySelector(".product-showcase__subscribe--option.is-selected, .product-showcase__subscribe--option.is-active");
//         if (!selected) return;
//         const type = selected.getAttribute("data-type") || "onetime";
//         toggleSubscriptionGuarantees(type)
//     }
//     document.addEventListener("pdp:gallery-updated", () => {
//         initProductVideo(), initMobileSwiper()
//     });

//     function ensureStickyVisible() {
//         const candidates = [document.querySelector("#sticky-add-to-cart"), document.querySelector(".sticky-add-to-cart"), document.querySelector("[data-sticky-add-to-cart]")];
//         for (const el of candidates)
//             if (el) {
//                 el.classList.remove("is-hidden", "hidden"), el.classList.add("is-visible"), el.setAttribute("aria-hidden", "false"), el.style.display = "";
//                 break
//             }
//     }
//     document.addEventListener("pdp:option-selected", function(ev) {
//         const d = ev.detail || {};
//         if (!d || d.source === "main") return;
//         const container = document.querySelector("#subscribe-options-static");
//         if (!container) return;
//         let target = null;
//         if (d.variantId && (target = container.querySelector(`.product-showcase__subscribe--option[data-variant-id="${d.variantId}"]`)), d.planId && (target = container.querySelector(`.product-showcase__subscribe--option[data-selling-plan-id="${d.planId}"]`)), !target && d.type && (target = container.querySelector(`.product-showcase__subscribe--option[data-type="${d.type}"]`)), !target) {
//             const atc = document.querySelector(".product-showcase__add-to-cart");
//             if (!atc) return;
//             const href = atc.getAttribute("href") || "/cart/add",
//                 url = new URL(href, window.location.origin);
//             if (url.searchParams.delete("selling_plan"), d.planId && url.searchParams.set("selling_plan", d.planId), d.variantId) url.searchParams.set("id", d.variantId);
//             else {
//                 let mainVariantId = "";
//                 const selBtn = document.querySelector(".product-variants--size .variant-product.variant-product-selected .variant-product__button");
//                 selBtn && (mainVariantId = selBtn.getAttribute("data-variant-id") || ""), mainVariantId || (mainVariantId = new URLSearchParams(location.search).get("variant") || ""), mainVariantId && url.searchParams.set("id", mainVariantId)
//             }
//             const qs = url.searchParams.toString();
//             atc.setAttribute("href", qs ? url.pathname + "?" + qs : url.pathname);
//             return
//         }
//         const evt = new Event("click", {
//             bubbles: !0,
//             cancelable: !0
//         });
//         target.dispatchEvent(evt)
//     });

//     function isSingleLayout() {
//         const root = document.querySelector("#subscribe-options-static");
//         return root ? root.querySelectorAll(".product-showcase__subscribe--container").length === 1 : !1
//     }

//     function ensureOpen(container) {
//         const actionsContainer = container.querySelector(".product-showcase__actions-container");
//         if (!actionsContainer) return;
//         actionsContainer.classList.add("dropdown-open");
//         const header = container.querySelector(".product-showcase__actions--header");
//         header && header.setAttribute("aria-expanded", "true")
//     }

//     function toggleDropdown(selectedOption) {
//         const container = selectedOption.closest(".product-showcase__subscribe--container");
//         if (container) {
//             if (isSingleLayout()) {
//                 ensureOpen(container);
//                 return
//             }
//             toggleDropdownByContainer(container)
//         }
//     }

//     function toggleDropdownByContainer(container) {
//         const actionsContainer = container.querySelector(".product-showcase__actions-container");
//         if (!actionsContainer) return;
//         if (isSingleLayout()) {
//             ensureOpen(container);
//             return
//         }
//         const isOpen = actionsContainer.classList.contains("dropdown-open"),
//             currentlyOpen = document.querySelector(".product-showcase__actions-container.dropdown-open");
//         if (isOpen) {
//             actionsContainer.classList.remove("dropdown-open");
//             const header2 = container.querySelector(".product-showcase__actions--header");
//             header2 && header2.setAttribute("aria-expanded", "false");
//             return
//         }
//         document.querySelectorAll(".product-showcase__actions-container.dropdown-open").forEach(oc => {
//             if (oc === actionsContainer) return;
//             oc.classList.remove("dropdown-open");
//             const h = oc.closest(".product-showcase__subscribe--container")?.querySelector(".product-showcase__actions--header");
//             h && h.setAttribute("aria-expanded", "false")
//         }), actionsContainer.classList.add("dropdown-open");
//         const header = container.querySelector(".product-showcase__actions--header");
//         header && header.setAttribute("aria-expanded", "true")
//     }
//     document.addEventListener("keydown", e => {
//         if (!(e.target instanceof Element)) return;
//         const header = e.target.closest(".product-showcase__subscribe--container .product-showcase__actions--header");
//         if (header && (e.key === "Enter" || e.key === " ")) {
//             e.preventDefault();
//             const container = header.closest(".product-showcase__subscribe--container");
//             container && toggleDropdownByContainer(container)
//         }
//     });

//     function initializeDropdowns() {
//         document.querySelectorAll(".product-showcase__actions-container").forEach(container => {
//             container.classList.remove("dropdown-open");
//             const header = container.closest(".product-showcase__subscribe--container")?.querySelector(".product-showcase__actions--header");
//             header && header.setAttribute("aria-expanded", "false")
//         }), document.querySelectorAll(".product-showcase__subscribe--option").forEach(opt => {
//             opt.classList.remove("is-selected", "is-active")
//         });
//         const firstContainer = document.querySelector(".product-showcase__subscribe--container:first-child");
//         if (firstContainer) {
//             const firstActionsContainer = firstContainer.querySelector(".product-showcase__actions-container");
//             if (firstActionsContainer) {
//                 firstActionsContainer.classList.add("dropdown-open");
//                 const header = firstContainer.querySelector(".product-showcase__actions--header");
//                 header && header.setAttribute("aria-expanded", "true")
//             }
//             const firstOption = firstContainer.querySelector(".product-showcase__subscribe--option");
//             firstOption && (firstOption.classList.add("is-selected"), firstOption.classList.add("is-active"))
//         }
//     }
//     document.addEventListener("DOMContentLoaded", initializeDropdowns);

//     function initMobileSwiper() {
//         if (typeof window > "u" || typeof window.Swiper > "u") return;
//         const SwiperCtor = window.Swiper;
//         if (!SwiperCtor) return;
//         try {
//             window.__psw?.mainSwiper && typeof window.__psw.mainSwiper.destroy == "function" && window.__psw.mainSwiper.destroy(!0, !0), window.__psw?.thumbsSwiper && typeof window.__psw.thumbsSwiper.destroy == "function" && window.__psw.thumbsSwiper.destroy(!0, !0)
//         } catch {}
//         const mainEl = document.querySelector(".product-showcase__gallery--mobile-main");
//         if (!mainEl) return;
//         const thumbsEl = document.querySelector(".product-showcase__gallery--mobile-thumbs"),
//             dotsEl = document.querySelector(".product-showcase__gallery--mobile-pagination");
//         let thumbsSwiper = null;
//         if (thumbsEl) {
//             try {
//                 rebuildThumbsFromMain(mainEl, thumbsEl)
//             } catch {}
//             thumbsSwiper = new SwiperCtor(thumbsEl, {
//                 slidesPerView: "auto",
//                 spaceBetween: 6,
//                 watchSlidesProgress: !0
//             })
//         }
//         const swiperConfig = {
//             spaceBetween: 10,
//             slidesPerView: 1
//         };
//         dotsEl && (swiperConfig.pagination = {
//             el: dotsEl,
//             clickable: !0,
//             bulletClass: "swiper-pagination-bullet",
//             bulletActiveClass: "swiper-pagination-bullet-active"
//         }), thumbsSwiper && (swiperConfig.thumbs = {
//             swiper: thumbsSwiper
//         });
//         const mainSwiper = new SwiperCtor(mainEl, swiperConfig);
//         window.__psw = {
//             mainSwiper,
//             thumbsSwiper
//         }
//     }

//     function rebuildThumbsFromMain(mainEl, thumbsEl) {
//         const wrapper = thumbsEl.querySelector(".swiper-wrapper"),
//             mainSlides = mainEl.querySelectorAll(".swiper-slide");
//         !wrapper || !mainSlides.length || (wrapper.innerHTML = "", mainSlides.forEach(slide => {
//             const img = slide.querySelector("img.product-showcase__image"),
//                 video = slide.querySelector("video.product-showcase__video-el"),
//                 slideEl = document.createElement("div");
//             slideEl.className = "swiper-slide";
//             const thumb = document.createElement("div");
//             if (thumb.className = "product-showcase__thumb", video) {
//                 thumb.classList.add("product-showcase__thumb--video");
//                 const v = document.createElement("video");
//                 v.muted = !0, v.autoplay = !0, v.loop = !0, v.setAttribute("playsinline", "");
//                 const poster = video.getAttribute("poster") || "";
//                 poster && v.setAttribute("poster", poster), thumb.appendChild(v);
//                 const icon = document.createElement("div");
//                 icon.className = "product-showcase__thumb-play-icon", icon.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M8 5v14l11-7z" fill="white"/></svg>', thumb.appendChild(icon)
//             } else if (img) {
//                 const timg = document.createElement("img");
//                 timg.className = "product-showcase__thumb-image", timg.src = img.currentSrc || img.src, timg.alt = img.alt || "", timg.width = 70, timg.height = 70, thumb.appendChild(timg)
//             }
//             slideEl.appendChild(thumb), wrapper.appendChild(slideEl)
//         }))
//     }
//     let isAddingToCart = !1;
//     async function handleAddToCartClick(e, button) {
//         if (console.log("Add to cart button clicked!", button), e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation(), !button) return;
//         if (isAddingToCart) {
//             console.log("Already adding to cart, ignoring duplicate call");
//             return
//         }
//         const href = button.getAttribute("href");
//         if (!href) return;
//         const url = new URL(href, window.location.origin),
//             variantId = url.searchParams.get("id"),
//             quantity = url.searchParams.get("quantity") || "1",
//             sellingPlan = url.searchParams.get("selling_plan");
//         if (!variantId) return;
//         isAddingToCart = !0, button.disabled = !0, button.classList.add("loading");
//         const originalText = button.innerHTML;
//         button.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none"><path d="M19 9.5C19 11.28 18.4722 13.0201 17.4832 14.5001C16.4943 15.9802 15.0887 17.1337 13.4442 17.8149C11.7996 18.4961 9.99002 18.6743 8.24419 18.3271C6.49836 17.9798 4.89471 17.1226 3.63604 15.864C2.37737 14.6053 1.5202 13.0016 1.17293 11.2558C0.825665 9.50998 1.0039 7.70038 1.68508 6.05585C2.36627 4.41131 3.51983 3.00571 4.99987 2.01677C6.47991 1.02784 8.21997 0.5 10 0.5" stroke="#2E2E24"/></svg>';
//         try {
//             const payload = {
//                 id: variantId,
//                 quantity: parseInt(quantity)
//             };
//             sellingPlan && (payload.selling_plan = sellingPlan);
//             const response = await fetch("/cart/add.js", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json",
//                     Accept: "application/json"
//                 },
//                 body: JSON.stringify(payload)
//             });
//             if (!response.ok) throw new Error("Failed to add to cart");
//             const result = await response.json();
//             document.dispatchEvent(new CustomEvent("cart:update-counter")), document.dispatchEvent(new CustomEvent("cart:refresh-open")), setTimeout(function() {
//                 button.classList.remove("loading"), button.innerHTML = "\u2713 Added!", setTimeout(function() {
//                     button.innerHTML = originalText, button.disabled = !1, isAddingToCart = !1
//                 }, 1e3)
//             }, 1e3)
//         } catch (error) {
//             console.error("[Product Showcase] Add to cart error:", error), alert("Error adding to cart. Please try again."), button.classList.remove("loading"), button.innerHTML = originalText, button.disabled = !1, isAddingToCart = !1
//         }
//     }

//     function initBundleVariantText() {
//         document.querySelectorAll(".product-variants--bundle").forEach(container => {
//             const selectedSpan = container.querySelector(".product-variants__selected"),
//                 activeButton = container.querySelector(".variant-product--active .variant-product__title");
//             selectedSpan && activeButton && (selectedSpan.textContent = activeButton.textContent || "")
//         })
//     }
//     initBundleVariantText(), document.addEventListener("pagebuilder:addtocart", async function(event) {
//         console.log("[Page Builder] Add to cart event received:", event.detail);
//         const {
//             variantId,
//             quantity,
//             sellingPlan
//         } = event.detail;
//         if (!variantId) {
//             console.error("[Page Builder] Variant ID is required");
//             return
//         }
//         if (isAddingToCart) {
//             console.log("[Page Builder] Already adding to cart, ignoring duplicate call");
//             return
//         }
//         isAddingToCart = !0;
//         try {
//             const payload = {
//                 id: variantId,
//                 quantity: parseInt(quantity) || 1
//             };
//             sellingPlan && (payload.selling_plan = sellingPlan), console.log("[Page Builder] Adding to cart with payload:", payload);
//             const response = await fetch("/cart/add.js", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json",
//                     Accept: "application/json"
//                 },
//                 body: JSON.stringify(payload)
//             });
//             if (!response.ok) {
//                 const errorData = await response.json();
//                 throw new Error(errorData.description || "Failed to add to cart")
//             }
//             const result = await response.json();
//             console.log("[Page Builder] Product added to cart:", result), document.dispatchEvent(new CustomEvent("cart:update-counter")), document.dispatchEvent(new CustomEvent("cart:refresh-open")), setTimeout(() => {
//                 isAddingToCart = !1
//             }, 1e3)
//         } catch (error) {
//             console.error("[Page Builder] Add to cart error:", error), alert("Error adding to cart: " + error.message), isAddingToCart = !1
//         }
//     })
// })(), window.addToCartFromPageBuilder = function(variantId, quantity, sellingPlan) {
//     if (console.log("[Page Builder] addToCartFromPageBuilder called with:", {
//             variantId,
//             quantity,
//             sellingPlan
//         }), !variantId) {
//         console.error("[Page Builder] Variant ID is required");
//         return
//     }
//     document.dispatchEvent(new CustomEvent("pagebuilder:addtocart", {
//         detail: {
//             variantId: variantId.toString(),
//             quantity: quantity || 1,
//             sellingPlan: sellingPlan ? sellingPlan.toString() : null
//         }
//     }))
// };

// (function() {
//     window.__MGO_VARIANTS_INIT__ = window && window.__MGO_VARIANTS_INIT__ || !1, !window.__MGO_VARIANTS_INIT__ && (window.__MGO_VARIANTS_INIT__ = !0, document.addEventListener("DOMContentLoaded", () => {
//         const container = document.querySelector(".product-variants__options"),
//             sizeContainer = document.querySelector(".product-variants--size .variant-products"),
//             ADD_TO_CART_SELECTOR = ".product-showcase__add-to-cart, #ps-add-to-cart";
//         let currentController = null,
//             lastPathname = null,
//             lastSelectedSizeValue = null;
//         container && (container.addEventListener("click", onVariantClick, !0), setVariantActiveFromUrl());

//         function updateBundleBlock(doc) {
//             const next = doc.querySelector(".product-variants--bundle"),
//                 curr = document.querySelector(".product-variants--bundle");
//             if (!next) {
//                 curr && curr.parentElement && curr.parentElement.removeChild(curr);
//                 return
//             }
//             if (curr) {
//                 curr.innerHTML = next.innerHTML;
//                 return
//             }
//             const info = document.querySelector(".product-showcase__info");
//             if (info) {
//                 const clone = next.cloneNode(!0),
//                     honeyBlock = info.querySelector(".product-variants.product-variants--honey");
//                 honeyBlock && honeyBlock.parentElement ? honeyBlock.parentElement.insertBefore(clone, honeyBlock.nextSibling) : info.insertBefore(clone, info.firstChild)
//             }
//         }

//         function updateBenefits(doc) {
//             const next = doc.querySelector(".product-showcase__info-block.block-table"),
//                 curr = document.querySelector(".product-showcase__info-block.block-table");
//             if (!next) {
//                 curr && curr.parentElement && curr.parentElement.removeChild(curr);
//                 return
//             }
//             if (!curr) {
//                 const info = document.querySelector(".product-showcase__info");
//                 if (info) {
//                     const clone = next.cloneNode(!0),
//                         titleBlock = info.querySelector(".product-showcase__info-block.block-title");
//                     titleBlock && titleBlock.parentElement ? titleBlock.parentElement.insertBefore(clone, titleBlock.nextSibling) : info.insertBefore(clone, info.firstChild)
//                 }
//                 return
//             }
//             curr.innerHTML = next.innerHTML
//         }

//         function updateReviewsBadge(doc) {
//             const next = doc.querySelector(".product-showcase__info-block.block-reviews-badge"),
//                 curr = document.querySelector(".product-showcase__info-block.block-reviews-badge");
//             !next || !curr || (curr.innerHTML = next.innerHTML)
//         }

//         function updateInfoTabs(doc) {
//             const next = doc.querySelector(".product-showcase__info-block.block-info-tabs"),
//                 curr = document.querySelector(".product-showcase__info-block.block-info-tabs"),
//                 placeholder = document.querySelector(".info-tabs-placeholder");
//             if (!next) {
//                 if (curr && curr.parentElement) {
//                     const ph = document.createElement("div");
//                     ph.className = "info-tabs-placeholder", ph.style.display = "none", curr.parentElement.insertBefore(ph, curr), curr.parentElement.removeChild(curr)
//                 }
//                 return
//             }
//             if (!curr) {
//                 const info = document.querySelector(".product-showcase__info");
//                 if (info) {
//                     const clone = next.cloneNode(!0);
//                     if (placeholder && placeholder.parentElement) placeholder.parentElement.insertBefore(clone, placeholder), placeholder.parentElement.removeChild(placeholder);
//                     else {
//                         const reviewsBlock = info.querySelector(".product-showcase__info-block.block-reviews-badge"),
//                             titleBlock = info.querySelector(".product-showcase__info-block.block-title");
//                         reviewsBlock && reviewsBlock.parentElement ? reviewsBlock.parentElement.insertBefore(clone, reviewsBlock.nextSibling) : titleBlock && titleBlock.parentElement ? titleBlock.parentElement.insertBefore(clone, titleBlock.nextSibling) : info.insertBefore(clone, info.firstChild)
//                     }
//                 }
//                 return
//             }
//             curr.innerHTML = next.innerHTML, placeholder && placeholder.parentElement && placeholder.parentElement.removeChild(placeholder)
//         }
//         async function updateProductInfoTabs(productUrl) {
//             const infoTabsSection = document.querySelector(".product-info");
//             if (!infoTabsSection) return;
//             const sectionId = infoTabsSection.getAttribute("data-section-id");
//             if (!sectionId) {
//                 console.warn("[MGO Variants] product-info-tabs section found but no data-section-id attribute");
//                 return
//             }
//             const sectionRenderUrl = new URL(productUrl, window.location.origin).pathname + "?section_id=" + encodeURIComponent(sectionId);
//             try {
//                 const resp = await fetch(sectionRenderUrl);
//                 if (!resp.ok) { 
//                     console.warn("[MGO Variants] Failed to fetch product-info-tabs:", resp.status);
//                     return
//                 }
//                 const html = await resp.text(),
//                     nextSection = new DOMParser().parseFromString(html, "text/html").querySelector(".product-info");
//                 if (nextSection) {
//                     const container2 = infoTabsSection.querySelector(".product-info__container"),
//                         nextContainer = nextSection.querySelector(".product-info__container");
//                     container2 && nextContainer ? container2.innerHTML = nextContainer.innerHTML : infoTabsSection.innerHTML = nextSection.innerHTML, document.dispatchEvent(new CustomEvent("product-info-tabs:update")), console.log("[MGO Variants] product-info-tabs updated successfully")
//                 } else console.warn("[MGO Variants] No .product-info found in fetched HTML")
//             } catch (err) {
//                 console.error("[MGO Variants] Product Info Tabs update error:", err)
//             }
//         }
//         async function updateJunipReviews(productUrl) {
//             const currentWidget = document.querySelector(".junip-product-review");
//             if (!currentWidget) {
//                 console.log("[MGO Variants] No Junip review widget found");
//                 return
//             }
//             const reviewSection = document.querySelector("#junip-review-section-custom");
//             if (!reviewSection) {
//                 console.log("[MGO Variants] No junip-review-section-custom found");
//                 return
//             }
//             let sectionId = reviewSection.getAttribute("data-section-id");
//             if (!sectionId) {
//                 const sectionElement = reviewSection.closest("[data-section-id]");
//                 sectionElement && (sectionId = sectionElement.getAttribute("data-section-id"))
//             }
//             if (!sectionId) {
//                 console.warn("[MGO Variants] No section ID found for Junip reviews");
//                 return
//             }
//             const sectionRenderUrl = new URL(productUrl, window.location.origin).pathname + "?section_id=" + encodeURIComponent(sectionId);
//             try {
//                 const resp = await fetch(sectionRenderUrl);
//                 if (!resp.ok) {
//                     console.warn("[MGO Variants] Failed to fetch Junip section:", resp.status);
//                     return
//                 }
//                 const html = await resp.text(),
//                     newWidget = new DOMParser().parseFromString(html, "text/html").querySelector(".junip-product-review");
//                 if (!newWidget) {
//                     console.log("[MGO Variants] No Junip widget in new product section");
//                     return
//                 }
//                 const newProductId = newWidget.getAttribute("data-product-id");
//                 if (!newProductId) {
//                     console.warn("[MGO Variants] No product ID in new Junip widget");
//                     return
//                 }
//                 console.log("[MGO Variants] Updating Junip reviews to product ID:", newProductId);
//                 const container2 = currentWidget.parentElement;
//                 if (container2) {
//                     currentWidget.remove();
//                     const newWidgetClone = newWidget.cloneNode(!0);
//                     container2.appendChild(newWidgetClone), console.log("[MGO Variants] Junip widget replaced with new product ID")
//                 }
//                 setTimeout(() => {
//                     const widget = document.querySelector(".junip-product-review");
//                     if (widget && (widget.setAttribute("data-product-id", newProductId), typeof window.junip < "u" && window.junip)) try {
//                         typeof window.junip.init == "function" && (window.junip.init(), console.log("[MGO Variants] window.junip.init() called successfully"))
//                     } catch (error) {
//                         console.error("[MGO Variants] Error calling window.junip.init():", error)
//                     }
//                 }, 100)
//             } catch (err) {
//                 console.error("[MGO Variants] Junip reviews update error:", err)
//             }
//         }
//         sizeContainer && (sizeContainer.addEventListener("click", onSizeClick, !0), setSizeActiveFromVariant()), initPurchaseOptions(), bindAddToCart(), ensureSizeBlockOnLoad(), setBundleActiveFromUrl();

//         function syncActionsPriceFromActiveOption() {
//             const active = document.querySelector(".product-showcase__subscribe--option.is-active");
//             if (!active || active.hasAttribute("data-variant-id")) return;
//             const type = active.getAttribute("data-type") || "",
//                 priceAttr = active.getAttribute("data-price-text") || "";
//             if (type.startsWith("subscription")) {
//                 const slot = document.querySelector("#pso-subscribe-price");
//                 slot && priceAttr && (slot.textContent = priceAttr)
//             } else if (type === "onetime") {
//                 const slot = document.querySelector("#pso-onetime-price");
//                 slot && priceAttr && (slot.textContent = priceAttr)
//             }
//             const headerPriceWrap = document.querySelector("#ps-slot-price, .product-showcase__price");
//             if (headerPriceWrap) {
//                 const curr = headerPriceWrap.querySelector(".product-showcase__current-price");
//                 curr && priceAttr && (curr.textContent = priceAttr)
//             }
//         }

//         function onVariantClick(e) {
//             const target = e.target.closest(".product-variants__option-button");
//             if (!target || !container || !container.contains(target)) return;
//             e.preventDefault(), e.stopImmediatePropagation();
//             const url = target.getAttribute("data-url") || "";
//             if (!url) return;
//             const selectedSizeBtn = document.querySelector(".product-variants--size .variant-product.variant-product-selected .variant-product__button");
//             selectedSizeBtn && (lastSelectedSizeValue = selectedSizeBtn.getAttribute("data-option-value")), container.querySelectorAll(".product-variants__option").forEach(li2 => li2.classList.remove("product-variants__option--active"));
//             const li = target.closest(".product-variants__option");
//             li && li.classList.add("product-variants__option--active"), handleSelect(url)
//         }

//         function onSizeClick(e) {
//             const target = e.target.closest(".variant-product__button"),
//                 currentSizeContainer = document.querySelector(".product-variants--size .variant-products");
//             if (!target || !currentSizeContainer || !currentSizeContainer.contains(target)) return;
//             e.preventDefault(), e.stopImmediatePropagation();
//             const variantId = target.getAttribute("data-variant-id");
//             if (!variantId) return;
//             const val = target.getAttribute("data-option-value") || null;
//             val && (lastSelectedSizeValue = val), handleSelectVariant(variantId)
//         }
//         async function handleSelect(productUrl) {
//             const resolvedUrl = new URL(productUrl, window.location.origin);
//             if (lastPathname === resolvedUrl.pathname) return;
//             const currentViewParam = new URLSearchParams(window.location.search).get("view");
//             currentViewParam && resolvedUrl.searchParams.set("view", currentViewParam), window.location.pathname !== resolvedUrl.pathname && window.history.replaceState({
//                 productUrl: resolvedUrl.href
//             }, "", resolvedUrl.href), currentController && currentController.abort(), currentController = new AbortController;
//             const sectionRoot = document.querySelector(".product-showcase"),
//                 sectionId = String(sectionRoot && sectionRoot.getAttribute("data-section-id") || ""),
//                 viewParam = new URLSearchParams(window.location.search).get("view");
//             let sectionRenderUrl = resolvedUrl.pathname + "?section_id=" + encodeURIComponent(sectionId);
//             viewParam && (sectionRenderUrl += "&view=" + encodeURIComponent(viewParam));
//             try {
//                 const html = await (await fetch(sectionRenderUrl, {
//                         signal: currentController.signal
//                     })).text(),
//                     doc = new DOMParser().parseFromString(html, "text/html");
//                 updateGallery(doc), updateTitle(doc), updatePrice(doc), updateAddToCart(doc), updateSelectedLabel(doc), updateDescription(doc), updateVariantsOptions(doc), updateSizeBlock(doc), updateBundleBlock(doc), updateBenefits(doc), updateInfoTabs(doc), updateReviewsBadge(doc), updateProductInfoTabs(resolvedUrl.href), updateJunipReviews(resolvedUrl.href), initPurchaseOptions(), bindAddToCart(), setVariantActiveFromUrl(), setSizeActiveFromVariant(), setBundleActiveFromUrl(), document.dispatchEvent(new CustomEvent("pdp:product-changed", {
//                     detail: {
//                         url: resolvedUrl.href
//                     }
//                 }));
//                 try {
//                     const badgeText = (doc.querySelector(".sticky-add-to-cart__product-percentage")?.textContent || "").trim();
//                     badgeText && document.dispatchEvent(new CustomEvent("sticky:badge-text", {
//                         detail: {
//                             text: badgeText
//                         }
//                     }))
//                 } catch {}
//                 try {
//                     syncActionsPriceFromActiveOption()
//                 } catch {}
//                 if (lastPathname = resolvedUrl.pathname, function() {
//                         if (!!new URLSearchParams(location.search).get("variant")) return;
//                         const sizeRoot = document.querySelector(".product-variants--size .variant-products");
//                         if (!sizeRoot) return;
//                         const items = sizeRoot.querySelectorAll(".variant-product");
//                         let def = null;
//                         if (items.length >= 2 ? def = items[1] : items.length >= 1 && (def = items[0]), !def) return;
//                         sizeRoot.querySelectorAll(".variant-product").forEach(li => li.classList.remove("variant-product-selected")), def.classList.add("variant-product-selected");
//                         const btn = def.querySelector(".variant-product__button"),
//                             v = btn && btn.getAttribute("data-option-value") || null;
//                         v && (lastSelectedSizeValue = v);
//                         const vid = btn && btn.getAttribute("data-variant-id") || "";
//                         vid && handleSelectVariant(vid)
//                     }(), lastSelectedSizeValue) {
//                     const matchBtn = doc.querySelector('.product-variants--size .variant-product__button[data-option-value="' + CSS.escape(lastSelectedSizeValue) + '"]');
//                     if (matchBtn) {
//                         const vid = matchBtn.getAttribute("data-variant-id");
//                         vid && handleSelectVariant(vid)
//                     }
//                 }
//             } catch (err) {
//                 if (err && err.name === "AbortError") return;
//                 console.error("[MGO Variants] Section render error:", err)
//             }
//         }

//         function initPurchaseOptions() {
//             const opts = document.querySelectorAll(".product-showcase__subscribe--option");
//             if (!opts.length) return;
//             let anyActive = !1;
//             if (opts.forEach(el => {
//                     const hasActive = el.classList.contains("is-active");
//                     el.hasAttribute("data-variant-id") ? hasActive && el.classList.remove("is-active") : hasActive && (anyActive = !0), el.removeEventListener("click", onPurchaseOptionClick, !0), el.addEventListener("click", onPurchaseOptionClick, !0)
//                 }), !anyActive) {
//                 const sub = document.querySelector('.product-showcase__subscribe--option[data-type^="subscription"]'),
//                     onetime = document.querySelector('.product-showcase__subscribe--option[data-type="onetime"]'),
//                     subPlanId = sub && sub.getAttribute("data-selling-plan-id") || "";
//                 let target = null;
//                 sub && !subPlanId && onetime ? target = onetime : sub ? target = sub : target = opts[0], target && setPurchaseOptionActive(target)
//             }
//         }

//         function onPurchaseOptionClick(e) {
//             const target = e.currentTarget;
//             e.preventDefault(), e.stopImmediatePropagation(), setPurchaseOptionActive(target)
//         }

//         function setPurchaseOptionActive(el) {
//             document.querySelectorAll(".product-showcase__subscribe--option").forEach(n => n.classList.remove("is-active")), el.hasAttribute("data-variant-id") || el.classList.add("is-active");
//             try {
//                 syncActionsPriceFromActiveOption()
//             } catch {}
//         }

//         function getActivePurchaseOption() {
//             const active = document.querySelector(".product-showcase__subscribe--option.is-active"),
//                 type = active ? active.getAttribute("data-type") : null,
//                 sellingPlanId = active && active.getAttribute("data-selling-plan-id") || "",
//                 variantId = active && active.getAttribute("data-variant-id") || "";
//             return {
//                 type,
//                 sellingPlanId,
//                 variantId
//             }
//         }

//         function bindAddToCart() {
//             const btns = document.querySelectorAll(ADD_TO_CART_SELECTOR);
//             btns.length && btns.forEach(btn => {
//                 btn.removeEventListener("click", onAddToCartClick, !0), btn.addEventListener("click", onAddToCartClick, !0)
//             })
//         }

//         function setBundleActiveFromUrl() {
//             const list = document.querySelector(".product-variants--bundle .variant-products");
//             if (!list) return;
//             const currentPath = window.location.pathname;
//             list.querySelectorAll(".variant-product").forEach(li => {
//                 li.classList.remove("variant-product-selected"), li.classList.remove("variant-product--active")
//             }), list.querySelectorAll(".variant-product__button").forEach(btnEl => {
//                 const btn = btnEl,
//                     url = btn.getAttribute("data-url") || "",
//                     path = url ? new URL(url, window.location.origin).pathname : "",
//                     li = btn.closest(".variant-product");
//                 li && (btn.classList.remove("variant-product__button--selected"), path === currentPath && (li.classList.add("variant-product-selected"), li.classList.add("variant-product--active"), btn.classList.add("variant-product__button--selected")))
//             })
//         }

//         function setBundleActiveByHandle(handle) {
//             if (!handle) return;
//             const list = document.querySelector(".product-variants--bundle .variant-products");
//             list && (list.querySelectorAll(".variant-product").forEach(li => {
//                 li.classList.remove("variant-product-selected"), li.classList.remove("variant-product--active")
//             }), list.querySelectorAll(".variant-product__button").forEach(btnEl => {
//                 const btn = btnEl,
//                     h = btn.getAttribute("data-product-handle") || "",
//                     li = btn.closest(".variant-product");
//                 li && (btn.classList.remove("variant-product__button--selected"), h === handle && (li.classList.add("variant-product-selected"), li.classList.add("variant-product--active"), btn.classList.add("variant-product__button--selected")))
//             }))
//         }
//         async function onAddToCartClick(e) {
//             const btn = e.currentTarget;
//             e.preventDefault(), e.stopImmediatePropagation();
//             let variantId = null;
//             const hrefNow = btn.getAttribute("href") || "";
//             let hrefIdParam = "",
//                 hrefSellingPlanParam = "";
//             try {
//                 const u = new URL(hrefNow, window.location.origin);
//                 hrefIdParam = u.searchParams.get("id") || "", hrefSellingPlanParam = u.searchParams.get("selling_plan") || ""
//             } catch {}
//             const {
//                 variantId: activeVariantId
//             } = getActivePurchaseOption();
//             if (hrefIdParam && (variantId = hrefIdParam), !variantId && activeVariantId && (variantId = activeVariantId), !variantId) {
//                 const m = hrefNow.match(/id=(\d+)/);
//                 m && (variantId = m[1])
//             }
//             if (variantId || (variantId = new URLSearchParams(location.search).get("variant")), !variantId) {
//                 const selBtn = document.querySelector(".product-variants--size .variant-product.variant-product-selected .variant-product__button");
//                 variantId = selBtn && selBtn.getAttribute("data-variant-id") || ""
//             }
//             if (!variantId) {
//                 console.warn("[MGO Variants] No variant ID to add.");
//                 return
//             }
//             const {
//                 type,
//                 sellingPlanId
//             } = getActivePurchaseOption(), effectiveSellingPlan = hrefSellingPlanParam || sellingPlanId || "", isSubscription = !!effectiveSellingPlan;
//             btn.classList.add("is-loading");
//             try {
//                 await addToCartAjax({
//                     id: Number(variantId),
//                     quantity: 1,
//                     selling_plan: isSubscription ? Number(effectiveSellingPlan) : void 0
//                 }), document.dispatchEvent(new CustomEvent("cart:item-added", {
//                     detail: {
//                         variantId,
//                         quantity: 1,
//                         sellingPlanId: isSubscription ? effectiveSellingPlan : null,
//                         type
//                     }
//                 })), document.dispatchEvent(new CustomEvent("cart:open")), document.dispatchEvent(new CustomEvent("cart:update-counter"))
//             } catch (err) {
//                 console.error("[MGO Variants] Add to cart error:", err);
//                 try {
//                     console.debug("[MGO Variants] Payload debug", {
//                         id: Number(variantId),
//                         quantity: 1,
//                         selling_plan: isSubscription ? Number(sellingPlanId) : void 0,
//                         type
//                     })
//                 } catch {}
//             } finally {
//                 btn.classList.remove("is-loading")
//             }
//         }
//         async function addToCartAjax(payload) {
//             const body = {
//                     id: payload.id,
//                     quantity: payload.quantity,
//                     ...payload.selling_plan ? {
//                         selling_plan: payload.selling_plan
//                     } : {}
//                 },
//                 resp = await fetch("/cart/add.js", {
//                     method: "POST",
//                     headers: {
//                         "Content-Type": "application/json",
//                         Accept: "application/json"
//                     },
//                     body: JSON.stringify(body)
//                 });
//             if (!resp.ok) {
//                 const txt = await resp.text().catch(() => "");
//                 throw new Error("Add to cart failed: " + resp.status + " " + txt)
//             }
//             return resp.json()
//         }
//         async function handleSelectVariant(variantId) {
//             const sectionRoot = document.querySelector(".product-showcase"),
//                 sectionId = String(sectionRoot && sectionRoot.getAttribute("data-section-id") || ""),
//                 basePath = window.location.pathname,
//                 params = new URLSearchParams(location.search);
//             params.set("variant", variantId);
//             const currentViewParam = new URLSearchParams(window.location.search).get("view");
//             currentViewParam && !params.has("view") && params.set("view", currentViewParam);
//             const newUrl = basePath + "?" + params.toString();
//             window.history.replaceState({
//                 variantId
//             }, "", newUrl), currentController && currentController.abort(), currentController = new AbortController;
//             const sectionUrl = basePath + "?section_id=" + encodeURIComponent(sectionId) + "&" + params.toString();
//             try {
//                 const html = await (await fetch(sectionUrl, {
//                         signal: currentController.signal
//                     })).text(),
//                     doc = new DOMParser().parseFromString(html, "text/html");
//                 updateGallery(doc), updatePrice(doc), updateAddToCart(doc), updateSizeBlock(doc), updateDescription(doc), updateBundleBlock(doc), updateReviewsBadge(doc), setSizeActiveFromVariant(), initPurchaseOptions(), bindAddToCart();
//                 try {
//                     const badgeText = (doc.querySelector(".sticky-add-to-cart__product-percentage")?.textContent || "").trim();
//                     badgeText && document.dispatchEvent(new CustomEvent("sticky:badge-text", {
//                         detail: {
//                             text: badgeText
//                         }
//                     }))
//                 } catch {}
//                 document.dispatchEvent(new CustomEvent("pdp:product-changed", {
//                     detail: {
//                         variantId
//                     }
//                 }))
//             } catch (err) {
//                 if (err && err.name === "AbortError") return;
//                 console.error("[MGO Variants] Variant change error:", err)
//             }
//         }

//         function updateGallery(doc) {
//             const nextDesktop = doc.querySelector(".product-showcase__gallery"),
//                 currDesktop = document.querySelector(".product-showcase__gallery");
//             nextDesktop && currDesktop && (currDesktop.innerHTML = nextDesktop.innerHTML);
//             const nextMobileWrap = doc.querySelector(".product-showcase__gallery--mobile-container"),
//                 currMobileWrap = document.querySelector(".product-showcase__gallery--mobile-container");
//             nextMobileWrap && currMobileWrap && (currMobileWrap.innerHTML = nextMobileWrap.innerHTML), document.dispatchEvent(new CustomEvent("pdp:gallery-updated"))
//         }

//         function updateTitle(doc) {
//             const next = doc.querySelector(".product-showcase__title"),
//                 curr = document.querySelector(".product-showcase__title");
//             next && curr && (curr.textContent = next.textContent)
//         }

//         function updatePrice(doc) {
//             const nextPrices = doc.querySelectorAll(".product-showcase__price"),
//                 currPrices = document.querySelectorAll(".product-showcase__price");
//             nextPrices.length && currPrices.length && nextPrices.forEach((nextPrice, index) => {
//                 currPrices[index] && (currPrices[index].innerHTML = nextPrice.innerHTML)
//             });
//             const nextOneTime = doc.querySelector("#pso-onetime-price"),
//                 currOneTime = document.querySelector("#pso-onetime-price");
//             nextOneTime && currOneTime && (currOneTime.innerHTML = nextOneTime.innerHTML || nextOneTime.textContent || "");
//             const nextSubsPrice = doc.querySelector("#pso-subscribe-price"),
//                 currSubsPrice = document.querySelector("#pso-subscribe-price");
//             nextSubsPrice && currSubsPrice && (currSubsPrice.innerHTML = nextSubsPrice.innerHTML || nextSubsPrice.textContent || "");
//             const nextSubsSave = doc.querySelector("#pso-subscribe-save"),
//                 currSubsSave = document.querySelector("#pso-subscribe-save");
//             nextSubsSave && currSubsSave && (currSubsSave.innerHTML = nextSubsSave.innerHTML || nextSubsSave.textContent || "");
//             const nextSubscribeOpts = doc.querySelector("#subscribe-options-static"),
//                 currSubscribeOpts = document.querySelector("#subscribe-options-static");
//             if (nextSubscribeOpts && currSubscribeOpts) {
//                 currSubscribeOpts.innerHTML = nextSubscribeOpts.innerHTML;
//                 const onetimeBtn = currSubscribeOpts.querySelector("#ps-add-to-cart-onetime");
//                 onetimeBtn && onetimeBtn.setAttribute("data-onetime-only", "true");
//                 const selectedOpt = currSubscribeOpts.querySelector(".product-showcase__subscribe--option.is-selected");
//                 selectedOpt && setTimeout(() => {
//                     const evt = new Event("click", {
//                         bubbles: !0,
//                         cancelable: !0
//                     });
//                     selectedOpt.dispatchEvent(evt)
//                 }, 10)
//             }
//         }

//         function updateAddToCart(doc) {
//             const nexts = doc.querySelectorAll(".product-showcase__add-to-cart"),
//                 currs = document.querySelectorAll(".product-showcase__add-to-cart");
//             if (!nexts.length || !currs.length) return;
//             let subscriptionHref = "";
//             for (const btn of nexts)
//                 if (!btn.hasAttribute("data-onetime-only") && (subscriptionHref = btn.getAttribute("href") || "", subscriptionHref)) break;
//             let onetimeVariantId = "";
//             const nextOnetimeBtn = doc.querySelector('.product-showcase__add-to-cart[data-onetime-only="true"]');
//             if (nextOnetimeBtn) {
//                 const onetimeHref = nextOnetimeBtn.getAttribute("href") || "";
//                 onetimeHref && (onetimeVariantId = new URL(onetimeHref, window.location.origin).searchParams.get("id") || "")
//             }
//             currs.forEach(el => {
//                 if (!el.hasAttribute("data-onetime-only")) subscriptionHref && el.setAttribute("href", subscriptionHref);
//                 else if (onetimeVariantId) {
//                     const onetimeUrl = new URL(el.getAttribute("href") || "/cart/add", window.location.origin);
//                     onetimeUrl.searchParams.set("id", onetimeVariantId), onetimeUrl.searchParams.delete("selling_plan");
//                     const onetimeHref = onetimeUrl.pathname + "?" + onetimeUrl.searchParams.toString();
//                     el.setAttribute("href", onetimeHref)
//                 }
//             })
//         }

//         function updateSelectedLabel(doc) {
//             const next = doc.querySelector(".product-variants__selected"),
//                 curr = document.querySelector(".product-variants__selected");
//             next && curr && (curr.textContent = next.textContent || "")
//         }

//         function updateDescription(doc) {
//             const nextById = doc.querySelector("#ps-slot-description"),
//                 currById = document.querySelector("#ps-slot-description");
//             if (nextById && currById) {
//                 currById.innerHTML = nextById.innerHTML;
//                 return
//             }
//             const next = doc.querySelector(".product-showcase__info-block.block-subtitle"),
//                 curr = document.querySelector(".product-showcase__info-block.block-subtitle");
//             next && curr && (curr.innerHTML = next.innerHTML)
//         }

//         function updateVariantsOptions(doc) {
//             document.querySelector(".product-variants__options")
//         }
//         async function ensureSizeBlockOnLoad() {
//             if (document.querySelector(".product-variants--size")) return;
//             const sectionRoot = document.querySelector(".product-showcase"),
//                 sectionId = String(sectionRoot && sectionRoot.getAttribute("data-section-id") || ""),
//                 basePath = window.location.pathname,
//                 params = new URLSearchParams(location.search),
//                 sectionUrl = basePath + "?section_id=" + encodeURIComponent(sectionId) + (params.size ? "&" + params.toString() : "");
//             try {
//                 const resp = await fetch(sectionUrl);
//                 if (!resp.ok) return;
//                 const html = await resp.text(),
//                     doc = new DOMParser().parseFromString(html, "text/html");
//                 updateSizeBlock(doc), setSizeActiveFromVariant()
//             } catch (e) {
//                 console.warn("[MGO Variants] ensureSizeBlockOnLoad failed:", e)
//             }
//         }

//         function updateSizeBlock(doc) {
//             const next = doc.querySelector(".product-variants--size"),
//                 curr = document.querySelector(".product-variants--size");
//             if (!next) {
//                 curr && curr.parentElement && curr.parentElement.removeChild(curr);
//                 return
//             }
//             if (curr) {
//                 curr.innerHTML = next.innerHTML;
//                 const newSizeContainer = curr.querySelector(".variant-products");
//                 newSizeContainer && newSizeContainer.addEventListener("click", onSizeClick, !0);
//                 return
//             }
//             const info = document.querySelector(".product-showcase__info");
//             if (info) {
//                 const clone = next.cloneNode(!0),
//                     honeyBlock = info.querySelector(".product-variants.product-variants--honey");
//                 honeyBlock && honeyBlock.parentElement ? honeyBlock.parentElement.insertBefore(clone, honeyBlock.nextSibling) : info.insertBefore(clone, info.firstChild);
//                 const newSizeContainer = clone.querySelector(".variant-products");
//                 newSizeContainer && newSizeContainer.addEventListener("click", onSizeClick, !0)
//             }
//         }

//         function setVariantActiveFromUrl() {
//             const list = document.querySelector(".product-variants__options");
//             if (!list) return;
//             const currentPath = window.location.pathname;
//             list.querySelectorAll(".product-variants__option-button").forEach(btnEl => {
//                 const btn = btnEl,
//                     url = btn.getAttribute("data-url") || "",
//                     path = url ? new URL(url, window.location.origin).pathname : "",
//                     li = btn.closest(".product-variants__option");
//                 li && (path === currentPath ? li.classList.add("product-variants__option--active") : li.classList.remove("product-variants__option--active"))
//             })
//         }

//         function setSizeActiveFromVariant() {
//             const list = document.querySelector(".product-variants--size .variant-products");
//             if (!list) return;
//             const currentVariant = new URLSearchParams(location.search).get("variant");
//             if (list.querySelectorAll(".variant-product").forEach(li => li.classList.remove("variant-product-selected")), list.querySelectorAll(".variant-product__button").forEach(btnEl => {
//                     const btn = btnEl,
//                         vid = btn.getAttribute("data-variant-id");
//                     if (!vid) return;
//                     const li = btn.closest(".variant-product");
//                     li && currentVariant && vid === currentVariant && li.classList.add("variant-product-selected")
//                 }), !currentVariant) {
//                 const items = list.querySelectorAll(".variant-product");
//                 let defaultItem = null;
//                 if (items.length >= 2 ? defaultItem = items[1] : items.length >= 1 && (defaultItem = items[0]), defaultItem) {
//                     list.querySelectorAll(".variant-product").forEach(li => li.classList.remove("variant-product-selected")), defaultItem.classList.add("variant-product-selected");
//                     const btn = defaultItem.querySelector(".variant-product__button"),
//                         v = btn && btn.getAttribute("data-option-value") || null;
//                     v && (lastSelectedSizeValue = v);
//                     const vid = btn && btn.getAttribute("data-variant-id") || "";
//                     vid && handleSelectVariant(vid)
//                 }
//             }
//         }
//         document.addEventListener("click", async evt => {
//             const btn = evt.target.closest(".product-variants--bundle .variant-product__button");
//             if (!btn) return;
//             evt.preventDefault();
//             const bundleRoot = document.querySelector(".product-variants--bundle .variant-products");
//             bundleRoot && (bundleRoot.querySelectorAll(".variant-product").forEach(el => {
//                 el.classList.remove("variant-product-selected"), el.classList.remove("variant-product--active")
//             }), bundleRoot.querySelectorAll(".variant-product__button").forEach(el => el.classList.remove("variant-product__button--selected")));
//             const li = btn.closest(".variant-product");
//             li && (li.classList.add("variant-product-selected"), li.classList.add("variant-product--active")), btn.classList.add("variant-product__button--selected");
//             const targetUrl = btn.dataset.url,
//                 sectionEl = document.querySelector(".product-showcase[data-section-id]");
//             if (!targetUrl || !sectionEl) return;
//             try {
//                 const resolved = new URL(targetUrl, window.location.origin);
//                 window.location.pathname !== resolved.pathname && window.history.replaceState({
//                     productUrl: resolved.href
//                 }, "", resolved.href)
//             } catch {}
//             const sectionId = sectionEl.getAttribute("data-section-id"),
//                 fetchUrl = `${targetUrl}?section_id=${encodeURIComponent(sectionId)}`;
//             try {
//                 const html = await (await fetch(fetchUrl, {
//                     credentials: "same-origin"
//                 })).text();
//                 if (typeof window.updatePdpFromSection == "function") window.updatePdpFromSection(html);
//                 else {
//                     const tmp = document.createElement("div");
//                     tmp.innerHTML = html;
//                     const newRoot = tmp.querySelector(".product-showcase"),
//                         oldRoot = document.querySelector(".product-showcase");
//                     newRoot && oldRoot && [".product-showcase__gallery", ".product-showcase__gallery--mobile-container", "#ps-slot-title", "#ps-slot-price", "#subscribe-options-static", ".product-variants--size", ".product-variants--bundle", ".block-table"].forEach(sel => {
//                         const oldNode = oldRoot.querySelector(sel),
//                             newNode = newRoot.querySelector(sel);
//                         oldNode && newNode && oldNode.replaceWith(newNode)
//                     })
//                 }
//                 initPurchaseOptions(), bindAddToCart(), setBundleActiveFromUrl();
//                 const clickedHandle = btn.getAttribute("data-product-handle") || btn.dataset.productHandle || "";
//                 clickedHandle && setBundleActiveByHandle(clickedHandle);
//                 const currentVariantParam = new URLSearchParams(location.search).get("variant"),
//                     clickedVariantId = btn.dataset.variantId;
//                 if (clickedVariantId && clickedVariantId !== currentVariantParam) try {
//                     await handleSelectVariant(String(clickedVariantId));
//                     try {
//                         syncActionsPriceFromActiveOption()
//                     } catch {}
//                     const clickedHandle2 = btn.getAttribute("data-product-handle") || btn.dataset.productHandle || "";
//                     clickedHandle2 && setBundleActiveByHandle(clickedHandle2)
//                 } catch (e) {
//                     console.warn("[MGO Variants] Bundle variant apply failed:", e)
//                 }
//                 const actionsHeader = document.querySelector(".product-showcase__actions--header");
//                 actionsHeader && actionsHeader.dispatchEvent(new MouseEvent("click", {
//                     bubbles: !0,
//                     cancelable: !0
//                 }));
//                 const subOption = document.querySelector('.product-showcase__subscribe--option[data-type^="subscription"]');
//                 subOption && (subOption.dispatchEvent(new MouseEvent("click", {
//                     bubbles: !0,
//                     cancelable: !0
//                 })), clickedVariantId && subOption.setAttribute("data-variant-id", String(clickedVariantId)));
//                 const atc = document.querySelector("#ps-add-to-cart");
//                 if (atc && clickedVariantId) try {
//                         const baseHref = atc.getAttribute("href") || "/cart/add",
//                             url = new URL(baseHref, window.location.origin);
//                         url.searchParams.set("id", String(clickedVariantId)), url.searchParams.get("quantity") || url.searchParams.set("quantity", "1"), atc.setAttribute("href", url.pathname + url.search)
//                     } catch (e) {
//                         console.warn("No se pudo actualizar el href del ATC", e)
//                     }(function() {
//                         const priceWrap = document.querySelector("#ps-slot-price, .product-showcase__price");
//                         if (!priceWrap) return;
//                         const current = priceWrap.querySelector(".product-showcase__current-price");
//                         if (!current || !current.textContent || !current.textContent.trim()) {
//                             const source = document.querySelector("#ps-slot-price .product-showcase__current-price, .product-showcase__price .product-showcase__current-price");
//                             source && current && (current.textContent = source.textContent || "")
//                         }
//                     })(),
//                     function() {
//                         const priceWrap = document.querySelector("#ps-slot-price, .product-showcase__price"),
//                             compareNode = priceWrap ? priceWrap.querySelector(".product-showcase__compare-price") : null,
//                             currentNode = priceWrap ? priceWrap.querySelector(".product-showcase__current-price") : null,
//                             compareText = compareNode ? (compareNode.textContent || "").trim() : "",
//                             priceText = currentNode ? (currentNode.textContent || "").trim() : "",
//                             planId = document.querySelector(".product-showcase__subscribe--option.is-active")?.getAttribute("data-selling-plan-id") || document.querySelector('.product-showcase__subscribe--option[data-type^="subscription"]')?.getAttribute("data-selling-plan-id") || "",
//                             type = planId ? "subscription" : "onetime";
//                         document.dispatchEvent(new CustomEvent("pdp:option-selected", {
//                             detail: {
//                                 type,
//                                 planId,
//                                 variantId: clickedVariantId || "",
//                                 priceText,
//                                 compareText
//                             }
//                         }))
//                     }(), typeof window.ensureStickyVisible == "function" && window.ensureStickyVisible(), document.dispatchEvent(new CustomEvent("pdp:product-changed"))
//             } catch (err) {
//                 console.error("Bundle switch failed", err)
//             }
//         })
//     }))
// })();
